import { render, staticRenderFns } from "./StorefrontIntegrationSystemConfigCards.vue?vue&type=template&id=53f0c57d"
import script from "./StorefrontIntegrationSystemConfigCards.vue?vue&type=script&lang=js"
export * from "./StorefrontIntegrationSystemConfigCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports